import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-08389fcd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mx-auto",
  src: _imports_0,
  alt: "MyParcel4you"
}, null, -1))
const _hoisted_2 = {
  class: "w-full flex items-end flex-col",
  style: {"margin-top":"30%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-orders text-big" }, null, -1))
const _hoisted_4 = { class: "ml-3 tracking-wider" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-bulk-orders text-big" }, null, -1))
const _hoisted_6 = { class: "ml-3 tracking-wider" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-return text-big" }, null, -1))
const _hoisted_8 = { class: "ml-3 tracking-wider" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-reports text-big" }, null, -1))
const _hoisted_10 = { class: "ml-3 tracking-wider" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-tracking text-big" }, null, -1))
const _hoisted_12 = { class: "ml-3 tracking-wider" }
const _hoisted_13 = {
  class: "w-full flex items-end flex-col",
  style: {"margin-top":"30%"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-account text-big" }, null, -1))
const _hoisted_15 = { class: "ml-3 tracking-wider" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-logout text-big" }, null, -1))
const _hoisted_17 = { class: "ml-3 tracking-wider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["nav-sidebar-overlay md:hidden", _ctx.show ? 'block' : 'hidden']),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('overlayClick')), ["self"]))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["nav-sidebar md:block w-3/5 md:w-1/5", _ctx.show ? 'block' : 'hidden'])
    }, [
      _createVNode(_component_router_link, { to: { name: 'homepage' } }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'parcels.list' },
          class: "nav-item md:w-5/6 w-full",
          "active-class": "nav-item--active"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("nav.parcels")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: { name: 'bulk_parcels.list' },
          class: "nav-item md:w-5/6 w-full",
          "active-class": "nav-item--active"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("nav.bulk_parcels")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: { name: 'return_parcels.list' },
          class: "nav-item md:w-5/6 w-full",
          "active-class": "nav-item--active"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("nav.returns")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: { name: 'reports.list' },
          class: "nav-item md:w-5/6 w-full",
          "active-class": "nav-item--active"
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("nav.reports")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        (_ctx.isInternalStaff)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'tracking_statuses.list' },
              class: "nav-item md:w-5/6 w-full",
              "active-class": "nav-item--active"
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("nav.tracking_statuses")), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("nav", _hoisted_13, [
        _createVNode(_component_router_link, {
          to: { name: 'account' },
          class: "nav-item md:w-5/6 w-full",
          "active-class": "nav-item--active"
        }, {
          default: _withCtx(() => [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("nav.account")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          class: "nav-item md:w-5/6 w-full",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('logoutClick')))
        }, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("nav.log_out")), 1)
        ])
      ])
    ], 2)
  ], 64))
}